module.exports = __webpack_public_path__ + "img/search-lg.aa7dc0d2.svg";